import { Link as RouterLink, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { adminNavItems } from './adminNav';

interface Props {
  onNavigate?: () => void;
}

export default function AdminMenuContent({ onNavigate }: Props) {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/admin/bookings') {
      return location.pathname === '/admin/bookings';
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <List dense sx={{ px: 0.5 }}>
      {adminNavItems.map((item) => {
        const Icon = item.icon;
        const selected = isActive(item.to);
        return (
          <ListItem key={item.to} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              component={RouterLink}
              to={item.to}
              selected={selected}
              onClick={onNavigate}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Icon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
